import { CandlePatternSetupModule } from '../../../../components/displays/alerts/components/addAlertComponent/addAlertForm/formComponents/setup/setupDetails/setupDetailsModules/candlePattern/CandlePatternSetupModule';
import { CandlePatternDetailsComponent } from '../../../../components/displays/alerts/components/alertWatchlistComponent/setupDetailsComponents/candlePattern/CandlePatternDetailsComponent';
import { CandlePatternBox } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/CandlePatternBox';
// import { CandlePatternTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/setups/candlePattern/CandlePatternTacticPanel';
import { CandlePatternWrapper } from '../../../../components/displays/tradeplans/softOrderModules/setupModules/candlePatternModule/wrapper/CandlePatternWrapper';
import CandlePatternDocumentation from '../../../../components/forms/tradeplans/documentation/CandlePatternDocumentation';
import { candlePatternDetailParser } from '../../../../stores/websocketStore/utils/mungingUtils/alertSoftOrderProcessing/individualSetupDetailParsers/candlePattern/candlePatternDetailParser';
import { determineCandlePatternCandleDuration } from '../../../../stores/websocketStore/utils/mungingUtils/alertSoftOrderProcessing/individualSetupDetailParsers/candlePattern/determineCandlePatternCandleDuration';
import { determineCandlePatternTimeUnit } from '../../../../stores/websocketStore/utils/mungingUtils/alertSoftOrderProcessing/individualSetupDetailParsers/candlePattern/determineCandlePatternTimeUnit';
import { CandlePatternData } from './candlePatternData';
import { validateCandlePattern } from './validateCandlePattern';
import { parseCandlePatternNotificationDetails } from '../../../../components/displays/alerts/components/notificationComponent/notificationListItem/notificationSetupParsers/parseCandlePatternNotificationDetails';

export const CandlePattern = {
  //data class
  dataStore: CandlePatternData,

  //string constants
  name: 'CANDLE_PATTERN',
  tacticLabel: 'Candle Pattern',
  addTacticLabel: 'Add Candle Pattern',
  category: 'Setup',

  // components
  tradePlanFormModule: null,
  // tacticPanel: CandlePatternTacticPanel,
  addTacticPanel: null,
  wrapper: CandlePatternWrapper,
  chartSoftOrderComponent: CandlePatternBox,
  documentation: CandlePatternDocumentation,
  alertDetailsComponent: CandlePatternSetupModule,
  alertTableSetupComponent: CandlePatternDetailsComponent,

  //functions
  setupDetailParser: candlePatternDetailParser,
  setupNotificationParser: parseCandlePatternNotificationDetails,
  determineTimeUnit: determineCandlePatternTimeUnit,
  determineCandleDuration: determineCandlePatternCandleDuration,
  validationFunction: validateCandlePattern,
};
